var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMultyValueCloseHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "button/close/pill/hover") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.8668942,5.13765643 C10.6894198,4.96018203 10.4027304,4.96018203 10.225256,5.13765643 L8,7.35836177 L5.77474403,5.1331058 C5.59726962,4.9556314 5.3105802,4.9556314 5.1331058,5.1331058 C4.9556314,5.3105802 4.9556314,5.59726962 5.1331058,5.77474403 L7.35836177,8 L5.1331058,10.225256 C4.9556314,10.4027304 4.9556314,10.6894198 5.1331058,10.8668942 C5.3105802,11.0443686 5.59726962,11.0443686 5.77474403,10.8668942 L8,8.64163823 L10.225256,10.8668942 C10.4027304,11.0443686 10.6894198,11.0443686 10.8668942,10.8668942 C11.0443686,10.6894198 11.0443686,10.4027304 10.8668942,10.225256 L8.64163823,8 L10.8668942,5.77474403 C11.039818,5.60182025 11.039818,5.3105802 10.8668942,5.13765643 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "button/close/pill/hover",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "close",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Neutral-Fill",
    mask: "url(#mask-2)",
    fill: "#5697B7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Fill",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMultyValueCloseHover);
export default __webpack_public_path__ + "static/media/icon_multy_value_close_hover.dac1d0f6ed48973a907026eccdb42ece.svg";
export { ForwardRef as ReactComponent };